interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
  article?: {
    headline: string;
    description: string;
    image: string;
    datePublished: string;
    dateModified: string;
    authorName: string;
    url: string;
  };
  faqs?: { question: string; answer: string }[];
}

export default function SchemaOrg({ type, data = {}, article, faqs }: SchemaOrgProps) {
  const baseUrl = 'https://www.laosege.com';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '老色哥',
    url: baseUrl,
    description: '老色哥是专为成熟男性打造的穿搭风格与生活美学平台，汇聚老色哥社区达人分享经典绅士穿搭、复古时尚搭配技巧。',
    logo: `${baseUrl}/logo.png`,
    sameAs: [
      'https://weibo.com/laosege',
      'https://www.xiaohongshu.com/user/laosege',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-21-6288-8888',
      contactType: 'customer service',
      email: 'contact@laosege.com',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '南京西路1788号世纪商贸广场18层',
      addressLocality: '上海',
      addressRegion: '静安区',
      postalCode: '200040',
      addressCountry: 'CN',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '老色哥',
    url: baseUrl,
    description: '老色哥是专为成熟男性打造的穿搭风格与生活美学平台，汇聚老色哥社区达人分享经典绅士穿搭、复古时尚搭配技巧，帮助中年男性找回自信魅力。',
    inLanguage: 'zh-CN',
    ...data,
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    ...data,
  };

  const articleSchema = article
    ? {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: article.headline,
        description: article.description,
        image: article.image,
        datePublished: article.datePublished,
        dateModified: article.dateModified,
        author: {
          '@type': 'Person',
          name: article.authorName,
        },
        publisher: {
          '@type': 'Organization',
          name: '老色哥',
          logo: {
            '@type': 'ImageObject',
            url: `${baseUrl}/logo.png`,
          },
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': article.url,
        },
      }
    : null;

  const faqSchema = faqs
    ? {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      }
    : null;

  let schema = null;
  switch (type) {
    case 'Organization':
      schema = organizationSchema;
      break;
    case 'WebSite':
      schema = websiteSchema;
      break;
    case 'WebPage':
      schema = webpageSchema;
      break;
    case 'Article':
      schema = articleSchema;
      break;
    case 'FAQPage':
      schema = faqSchema;
      break;
  }

  if (!schema) return null;

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}